import { Timestamp } from "firebase/firestore";
// biome-ignore lint/suspicious/noExplicitAny: <allow sentinels>
function toDate(val) {
    if (val instanceof Date)
        return val;
    if (typeof val === "string" &&
        val.length > 0 &&
        !Number.isNaN(Date.parse(val))) {
        return new Date(val);
    }
    return null;
}
// biome-ignore lint/suspicious/noExplicitAny: <allow sentinels>
export function prepareForFirestore(obj) {
    // biome-ignore lint/correctness/noUnusedVariables: <remove id and path>
    const { id, path, createdAt, updatedAt, ...rest } = obj;
    const createdDate = toDate(createdAt);
    const updatedDate = toDate(updatedAt);
    return {
        ...rest,
        ...(createdDate && { createdAt: Timestamp.fromDate(createdDate) }),
        ...(updatedDate && { updatedAt: Timestamp.fromDate(updatedDate) }),
    };
}
